import Hinnasto from "../components/Hinnasto";

function HinnastoPage(){
    return <div>
        <Hinnasto/>
    </div>
}

export default HinnastoPage;